import { Injectable } from "@angular/core";
import { HelpAPIConstant } from "../constant/help.constant";
import { RestService } from "../../../core/service/rest.service";
import { AttachmentService } from "../../../common/service/attachment.service";

@Injectable({
    providedIn: 'root'
})
export class HelpService {
    constructor(private rest: RestService, private attachmentService: AttachmentService) { }

    getTags(payload: any) { return this.rest.get(HelpAPIConstant.TAGS, payload) }
    getHelpItems(payload: any) { return this.rest.get(HelpAPIConstant.GET_HELP_ITEMS, payload) }
    addHelpItems(payload: any) { return this.rest.post(HelpAPIConstant.ADD_HELP_ITEMS, payload, { 'Content-Type': 'multipart/form-data' }) }
    updateHelpItems(payload: any, documentId: number) { return this.rest.put(HelpAPIConstant.UPDATE_HELP_ITEMS + '/' + documentId, payload) }
    deleteHelpItem(helpItemDocumentId: number) { return this.rest.delete(HelpAPIConstant.DELETE_HELP_ITEM + '/' + helpItemDocumentId) }
    downloadAttachments(fileName: string) { return this.rest.download(HelpAPIConstant.ATTACHMENTS + '/' + fileName, {},) } 
}